export const SHOW_EMPTY_RESULTS = "SHOW_EMPTY_RESULTS";
export const CHANGE_RESULT_DISPLAY = "CHANGE_RESULT_DISPLAY";
export const TOGGLE_VIEW_DROPDOWN = "TOGGLE_VIEW_DROPDOWN";

export const showEmptyResults = () => ({ type: SHOW_EMPTY_RESULTS });